/** 角色管理API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/sys/role';
/**
 * 分页查询
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Sys.Role> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Sys.Role> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个角色
 *
 * @param id 角色ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Sys.Role> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存角色
 *
 * @param params 角色信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新角色信息
 *
 * @param params 角色信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除角色
 *
 * @param id 角色ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除角色
 *
 * @param ids 角色ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
